/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { RichTextComponent } from '@msdyn365-commerce/core';
import classnames from 'classnames';
import * as React from 'react';
import { IUnsubscribeNewsletterProps } from './unsubscribe-newsletter.props.autogenerated';

export interface IUnsubscribeNewsletterViewProps extends IUnsubscribeNewsletterProps<{}> {
    paragraph?: React.ReactNode;
    secondaryParagraph?: React.ReactNode;
    privacyPolicyText?: React.ReactNode;
    className?: string;
}

/**
 *
 * NewsletterBlock component
 */
class UnsubscribeNewsletter extends React.PureComponent<IUnsubscribeNewsletterProps<{}>> {
    public render(): JSX.Element | null {
        const { paragraph, secondaryParagraph, className } = this.props.config;

        const text = paragraph && <RichTextComponent text={paragraph} />;
        const secondaryText = secondaryParagraph && <RichTextComponent text={secondaryParagraph} />;

        const unsubscribeNewsletterViewProps = {
            ...this.props,
            paragraph: text,
            secondaryParagraph: secondaryText,
            className: classnames('unsubscribe-newsletter-block', className)
        };
        return this.props.renderView(unsubscribeNewsletterViewProps) as React.ReactElement;
    }
}
export default UnsubscribeNewsletter;
